/**
 * @generated SignedSource<<53f241ddcee5700b15a3aff8a7b9d21b>>
 * @relayHash 5b748083954b93cff445a0b2642d75c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c748d85a3e6e9e9bfab69020f4b21f84cc6717e98814465f38d3338d3dd4a9cd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c748d85a3e6e9e9bfab69020f4b21f84cc6717e98814465f38d3338d3dd4a9cd",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
